import { FC, useState } from 'react'
import { useForm, FormProvider } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import Dialog from 'components/Common/Modals/Dialog'
import { Body } from './_styles'
import { FIELDS, STEPS } from './_methods'
import Form from './Form'
import RecognitionResult from '../ImagesUpdateDialog/RecognitionResult'
import { useRecognizeWine } from './_methods/useRecognizeWine'
import { RecognitionResultProduct } from 'api/fragments/types'

interface RecognizeWineDialogProps {
  onClose: () => void
  onConfirm: (productRecognition: RecognitionResultProduct) => void
}

const RecognizeWineDialog: FC<RecognizeWineDialogProps> = ({
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation()
  const [step, setStep] = useState(STEPS.uploadImages)

  const methods = useForm({
    defaultValues: {
      [FIELDS.RECOGNITION_DATA]: null,
      [FIELDS.BOTTLE_IMAGES]: {
        frontLabel: null,
        backLabel: null,
        bottleLabel: null,
      },
      [FIELDS.ADDITIONAL_IMAGES]: {
        first: null,
        second: null,
        third: null,
      },
    },
  })

  const {
    isSubmitting,
    handleRecognise,
    handleIncorrectRecognition,
    handleConfirm,
  } = useRecognizeWine({
    methods,
    setStep,
    onConfirm,
  })

  const changeStep = (step: number) => setStep(step)

  return (
    <Dialog.Wrapper
      withMobileVariant
      onClose={onClose}
      dataTestId='recognize-wine-modal'
    >
      <Dialog.Main width='590px'>
        <Dialog.Header
          title={t('dialogs.recognizeWine.header')}
          onClose={onClose}
          dataTestId='recognize-wine-modal-header'
          closeButtonTestId='recognize-wine-modal-close-button'
        />
        <Dialog.Content>
          <Body data-testid='recognize-wine-modal-body'>
            <FormProvider {...methods}>
              {step === STEPS.uploadImages && (
                <Form
                  loading={isSubmitting}
                  handleRecognise={handleRecognise}
                  onClose={onClose}
                />
              )}
              {step === STEPS.recognizedWine && (
                <RecognitionResult
                  handleIncorrectRecognition={handleIncorrectRecognition}
                  changeStep={changeStep}
                  handleUpdate={handleConfirm}
                  isLoading={isSubmitting}
                  onClose={onClose}
                  isRecognizeWineMode={true}
                  testIdPrefix='recognize-wine-modal'
                />
              )}
            </FormProvider>
          </Body>
        </Dialog.Content>
      </Dialog.Main>
    </Dialog.Wrapper>
  )
}

export default RecognizeWineDialog
